import { render, staticRenderFns } from "./ClientListItem.vue?vue&type=template&id=5426607a&scoped=true&"
import script from "./ClientListItem.vue?vue&type=script&lang=js&"
export * from "./ClientListItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientListItem.vue?vue&type=style&index=0&id=5426607a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5426607a",
  null
  
)

export default component.exports